export default {
  ...process.env,
  QRCODE_LIMIT: 180000 // 3分钟
}



// WEBPACK FOOTER //
// ./src/store/config.js